var _classCallCheck = require("/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/node_modules/@babel/runtime/helpers/inherits");

(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports, require('react')) : typeof define === 'function' && define.amd ? define(['exports', 'react'], factory) : (global = global || self, factory(global['error-boundary'] = {}, global.React));
})(this, function (exports, React) {
  'use strict';

  React = React && React.hasOwnProperty('default') ? React['default'] : React;

  var ErrorBoundary =
  /*#__PURE__*/
  function (_React$Component) {
    _inherits(ErrorBoundary, _React$Component);

    function ErrorBoundary(props) {
      var _this;

      _classCallCheck(this, ErrorBoundary);

      _this = _possibleConstructorReturn(this, _getPrototypeOf(ErrorBoundary).call(this, props));
      _this.state = {
        hasError: false
      };
      return _this;
    }

    _createClass(ErrorBoundary, [{
      key: "componentDidCatch",
      value: function componentDidCatch(error, errorInfo) {
        // FIXME: Log this somewhere
        console.log(error, errorInfo);
      }
    }, {
      key: "render",
      value: function render() {
        if (this.state.hasError) {
          return this.props.renderOnError;
        }

        return this.props.children;
      }
    }], [{
      key: "getDerivedStateFromError",
      value: function getDerivedStateFromError(error) {
        return {
          hasError: true
        };
      }
    }]);

    return ErrorBoundary;
  }(React.Component);

  exports.ErrorBoundary = ErrorBoundary;
  Object.defineProperty(exports, '__esModule', {
    value: true
  });
});